import { render, staticRenderFns } from "./suggestionList.vue?vue&type=template&id=413cd13e&scoped=true&"
import script from "./suggestionList.vue?vue&type=script&lang=js&"
export * from "./suggestionList.vue?vue&type=script&lang=js&"
import style0 from "./suggestionList.vue?vue&type=style&index=0&id=413cd13e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413cd13e",
  null
  
)

export default component.exports